/**
 * [TD-68 Section 2.4 / Verdict 8.A] Frontend email-list parser.
 *
 * Splits on whitespace, commas, semicolons. Filters out empty tokens.
 * Validates each token via the same regex the backend uses
 * (`^[^@\s]+@[^@\s]+\.[^@\s]+$`).
 *
 * Returns: `{ valid: string[], invalid: string[] }`
 */

export const INVITE_EMAIL_REGEX_SOURCE = "^[^@\\s]+@[^@\\s]+\\.[^@\\s]+$";
export const INVITE_EMAIL_REGEX = new RegExp(INVITE_EMAIL_REGEX_SOURCE);

export function parseInviteEmails(input) {
  if (typeof input !== "string" || !input.trim()) {
    return { valid: [], invalid: [] };
  }
  const tokens = input
    .split(/[\s,;]+/)
    .map((s) => s.trim())
    .filter(Boolean);
  const valid = [];
  const invalid = [];
  const seen = new Set();
  for (const t of tokens) {
    if (seen.has(t.toLowerCase())) continue; // collapse duplicates client-side
    seen.add(t.toLowerCase());
    if (INVITE_EMAIL_REGEX.test(t)) valid.push(t);
    else invalid.push(t);
  }
  return { valid, invalid };
}
